import React from "react";

const PERSONAS = [
  {
    title: "Side Sleepers",
    body: "Wake without shoulder ache",
    img: "/assets/side_sleepers.png",
    bg: "bg-[#dceaff]",
  },
  {
    title: "Pro Athletes",
    body: "Recover faster, train harder",
    img: "/assets/pro_athletes.png",
    bg: "bg-[#ececec]",
  },
  {
    title: "Insomniacs",
    body: "Fall asleep, stay asleep",
    img: "/assets/insomniacs.png",
    bg: "bg-[#ffd9e0]",
  },
  {
    title: "Frequent Flyers",
    body: "Hotel-grade sleep at home",
    img: "/assets/frequent_flyers.png",
    bg: "bg-[#fde8c8]",
  },
];

export default function Personas() {
  return (
    <section className="aurora-wrap py-20 md:py-28">
      <div className="container-x">
        <div className="text-center">
          <h2 className="text-[34px] sm:text-[44px] md:text-[56px] leading-[1.05] font-black tracking-[-0.02em] text-[#0e0e10]">
            For Sleepers. For Athletes.
            <br />
            For Anyone Who's Tired Of Being Tired.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {PERSONAS.map((p) => (
            <div key={p.title} className={`persona-card ${p.bg}`}>
              <div className="aspect-square overflow-hidden rounded-2xl mb-5">
                <img
                  src={p.img}
                  alt={p.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-[17px] md:text-[19px] font-extrabold text-[#0e0e10]">
                {p.title}
              </h3>
              <p className="mt-1.5 text-[13px] text-[#2a2a2e]/70">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
